// eslint-disable-next-line import/prefer-default-export
export const isSearchIntersectional = ({ params, adsBanners }) => {
  return (
    params.trackSource === 'search' &&
    Boolean(adsBanners?.searchIntersectional?.enable)
  );
};
